 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import LOVE_2 from '@/components/love_2'
 import BOOKDESCRIPTION from '@/components/book-description'
 import UNTITLED from '@/components/untitled'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import FOREWORDMYSTICRHYTHMS from '@/components/foreword-mystic-rhythms'
 import FULLPAGEIMAGE from '@/components/full-page-image'
 import DRUMBEATS from '@/components/drumbeats'
 import AFTERWORDSTORIESTHATFIREDMYIMAGINATION from '@/components/afterword-stories-that-fired-my-imagination'
 import ABOUTTHEAUTHORS from '@/components/about-the-authors'
 import ABOUTTHEARTIST from '@/components/about-the-artist'
 import IFYOULIKED from '@/components/if-you-liked'
 import OTHERWORDFIREPRESSTITLESBYKEVINJANDERSON from '@/components/other-wordfire-press-titles-by-kevin-j-anderson'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/love_2",
 			"name" : "love_2",
 			"component" : LOVE_2
 		},
 		{
 			"path" : "/book-description",
 			"name" : "book-description",
 			"component" : BOOKDESCRIPTION
 		},
 		{
 			"path" : "/untitled",
 			"name" : "untitled",
 			"component" : UNTITLED
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js